import axios from "axios";
import axiosbaseUrl from "../../http/axios";

import * as actionTypes from "./actionTypes";
export const GET_MANAGMENT_DATA = "GET_MANAGMENT_DATA";
export const GET_CURRENT_MANAGMENT_DATA = "GET_CURRENT_MANAGMENT_DATA";

export function getManagmanetData() {
  const request = axios.get(
    `${process.env.PUBLIC_URL}/Mock_Managment_dashboard_data.json`
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_MANAGMENT_DATA,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}

export function getCurrentManagmanetData(token, name, from, to) {
  const request = axiosbaseUrl.get(
    `/reports/${name}/?${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_CURRENT_MANAGMENT_DATA,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}



// WEBPACK FOOTER //
// ./src/store/actions/managmantDashboardData.js